<template lang="html">
  <div class="add-company-user">
    <Overlay
      width="small"
      autoHeight
      :link="{name: 'company-users', params: {companyId: companyId}}"
    >
      <Notification
        :withinOverlay="true"
        v-if="notification.active"
        :content="notification.content"
        :type="notification.type"
      />

      <h2 class="overlay-heading">Invite user to {{ companyName }}</h2>

      <company-user-form
        @submit="submitCompanyUser"
        @setUserPermissions="setUserPermissions"
        v-model="user"
        :availablePermissions="availablePermissions"
        :errors="errors"
      />
    </Overlay>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import page from '@/mixins/page'
import notification from '@/mixins/notification'
import {createCompanyUserData} from '@/lib/company_users'

import Overlay from '@/components/Overlay'
import CompanyUserForm from '@/components/forms/CompanyUserForm'

export default {
  name: 'AddCompanyUser',

  mixins: [page, notification],

  props: {
    companyId: String,
    companyName: String
  },

  components: {
    CompanyUserForm,
    Overlay
  },

  data() {
    return {
      uuser: {permissions: {}},
      title: 'New Company User',
      errors: {}
    }
  },

  computed: {
    ...mapState(['currentUser']),

    availablePermissions() {
      return this.currentUser.permissions
    },

    user: {
      get() {
        // set empty array for each available permission relm so that vue
        // witchcraft kicks in and we can populate permission relm actions via
        // checkboxes.
        let user = this.uuser

        Object.keys(this.availablePermissions).forEach((relm) => {
          if (!user.permissions[relm]) {
            user.permissions[relm] = []
          }
        })

        return user
      },

      set(value) {
        this.uuser = value
      }
    }
  },

  methods: {
    submitCompanyUser() {
      createCompanyUserData(this.companyId, this.user)
        .then(({data}) => {
          this.triggerNotification('success', 'company user', 'invited')

          window.setTimeout(() => {
            this.$router.push({
              name: 'company-users',
              params: {companyId: data.company_id}
            })
          }, this.closeDelay)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    setLimitedRole() {
      const restrictedPermissions = ['default', 'permission', 'user']
      const resources = ['article', 'company_user', 'page', 'contact', 'mailchimp', 'company', 'site', 'list_type', 'list', 'list_item', 'theme']

      Object.keys(this.availablePermissions).forEach((relm) => {
        if (resources.includes(relm)) {
          this.uuser.permissions[relm] = ['list', 'read']
        } else if (!restrictedPermissions.includes(relm)) {
          this.uuser.permissions[relm] = [
            'list',
            'create',
            'read',
            'update',
            'delete'
          ]
        }
      })
    },

    setEditorRole() {
      const restrictedPermissions = ['default', 'permission', 'user']
      const listResources = ['list_type', 'theme', 'company_user']
      const readUpdateResources = ['site']
      const readResources = ['company']
      const crudResources = ['article', 'page', 'contact', 'mailchimp', 'list', 'list_item']

      Object.keys(this.availablePermissions).forEach((relm) => {
        if (crudResources.includes(relm)) {
          this.uuser.permissions[relm] = ['create', 'read', 'update', 'delete', 'list']
        } else if (readUpdateResources.includes(relm)) {
          this.uuser.permissions[relm] = ['list', 'read', 'update']
        } else if (readResources.includes(relm)) {
          this.uuser.permissions[relm] = ['read']
        } else if (listResources.includes(relm)) {
          this.uuser.permissions[relm] = ['list', 'read']
        } else if (!restrictedPermissions.includes(relm)) {
          this.uuser.permissions[relm] = [
            'list',
            'create',
            'read',
            'update',
            'delete'
          ]
        }
      })
    },

    setSameRole() {
      this.uuser.permissions = this.availablePermissions
    },

    setUserPermissions(role) {
      let functionName = `set${role}Role`
      this[functionName]()
    }
  }
}
</script>
